var _g, _rect, _rect2, _rect3, _g2, _rect4, _g3, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 16,
    viewBox: "0 0 108 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1480_9219)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 3.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68941 5.00999L7.17571 11.0074H5.53571L4.29871 6.22119C4.22361 5.92639 4.15831 5.81839 3.92991 5.69419C3.55701 5.49189 2.94121 5.30209 2.39941 5.18429L2.43621 5.00999H5.07611C5.41261 5.00999 5.71511 5.23399 5.79151 5.62149L6.44481 9.09189L8.05941 5.00989H9.68921L9.68941 5.00999ZM16.1152 9.04929C16.1218 7.46639 13.9264 7.37919 13.9415 6.67209C13.9462 6.45689 14.1511 6.22809 14.5996 6.16969C14.8219 6.14059 15.4344 6.11839 16.1291 6.43809L16.4016 5.16629C16.0283 5.03079 15.548 4.90039 14.9504 4.90039C13.4169 4.90039 12.3377 5.71559 12.3286 6.88289C12.3187 7.74629 13.0989 8.22809 13.6867 8.51499C14.2914 8.80879 14.4943 8.99759 14.492 9.26039C14.4877 9.66269 14.0097 9.84029 13.563 9.84729C12.7832 9.85929 12.3307 9.63629 11.97 9.46859L11.6888 10.7825C12.0513 10.9488 12.7204 11.0939 13.4141 11.1012C15.044 11.1012 16.1102 10.2961 16.1152 9.04929ZM20.1646 11.0074H21.5995L20.347 5.00999H19.0226C18.7248 5.00999 18.4736 5.18339 18.3624 5.44999L16.0343 11.0074H17.6634L17.9869 10.1115H19.9774L20.1647 11.0074H20.1646ZM18.4335 8.88239L19.2501 6.63059L19.7201 8.88239H18.4336H18.4335ZM11.9061 5.00999L10.6232 11.0074H9.07181L10.3552 5.00999H11.9061Z",
    fill: "#1434CB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.266666,
    y: 0.266666,
    width: 23.4667,
    height: 15.4667,
    rx: 2.93333,
    stroke: "#CAD4DD",
    strokeWidth: 0.533333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2667,
    y: 0.266666,
    width: 23.4667,
    height: 15.4667,
    rx: 2.93333,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2667,
    y: 0.266666,
    width: 23.4667,
    height: 15.4667,
    rx: 2.93333,
    stroke: "#CAD4DD",
    strokeWidth: 0.533333
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1480_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0066 4.37695H37.9746V11.6226H42.0066V4.37695Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2327 8.00057C38.2321 7.30277 38.3902 6.61396 38.6951 5.9863C39.0001 5.35865 39.4438 4.80859 39.9927 4.37777C39.3129 3.84345 38.4965 3.51117 37.6369 3.4189C36.7772 3.32662 35.9089 3.47808 35.1312 3.85597C34.3535 4.23386 33.6978 4.82293 33.2391 5.55584C32.7804 6.28875 32.5371 7.13594 32.5371 8.00057C32.5371 8.8652 32.7804 9.71239 33.2391 10.4453C33.6978 11.1782 34.3535 11.7673 35.1312 12.1452C35.9089 12.5231 36.7772 12.6745 37.6369 12.5822C38.4965 12.49 39.3129 12.1577 39.9927 11.6234C39.4438 11.1925 39.0001 10.6425 38.6951 10.0148C38.3902 9.38718 38.2321 8.69837 38.2327 8.00057Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4417 8.00057C47.4417 8.86519 47.1985 9.71237 46.7398 10.4453C46.2811 11.1782 45.6254 11.7673 44.8478 12.1452C44.0701 12.523 43.2018 12.6745 42.3421 12.5822C41.4825 12.49 40.6661 12.1577 39.9863 11.6234C40.5348 11.1921 40.9782 10.642 41.283 10.0144C41.5879 9.38685 41.7463 8.69826 41.7463 8.00057C41.7463 7.30288 41.5879 6.61429 41.283 5.98673C40.9782 5.35917 40.5348 4.80902 39.9863 4.37777C40.6661 3.84345 41.4825 3.51116 42.3421 3.41889C43.2018 3.32662 44.0701 3.47809 44.8478 3.85598C45.6254 4.23388 46.2811 4.82294 46.7398 5.55586C47.1985 6.28877 47.4417 7.13595 47.4417 8.00057Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0046 10.8546V10.7063H47.0644V10.6761H46.9121V10.7063H46.9719V10.8546H47.0046ZM47.3004 10.8546V10.6758H47.2537L47.2 10.7988L47.1462 10.6758H47.0995V10.8546H47.1325V10.7197L47.1829 10.836H47.2171L47.2674 10.7194V10.8546H47.3004Z",
    fill: "#F79E1B"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    width: 24,
    height: 16,
    rx: 3.2,
    fill: "#006FCF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1480_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9941 16H72.0421H63.9941V7.92064V0H71.9349H79.9941V7.99936V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9941 16V13.4646H78.0639L77.07 12.3658L76.0713 13.4646H69.7071V8.34304H67.653L70.2009 2.57696H72.6581L73.5353 4.55232V2.57696H76.5769L77.1049 4.0656L77.6364 2.57696H79.9941V0H63.9941V16H79.9941ZM78.389 12.8234H79.9941L77.8709 10.5718L79.9941 8.34592H78.4146L77.1033 9.77888L75.8047 8.34592H74.1993L76.31 10.5846L74.1993 12.8234H75.7602L77.078 11.3776L78.3893 12.8234H78.389ZM78.7647 10.5738L79.9941 11.8819V9.27648L78.7647 10.5738ZM71.6085 11.7872V11.0899H74.1353V10.0794H71.6085V9.38208H74.1993V8.34592H70.3868V12.8237H74.1993V11.7875H71.6085V11.7872ZM78.7852 7.696H79.9941V3.21824H78.1135L77.109 6.00704L76.1113 3.21824H74.1986V7.696H75.4076V4.5616L76.5589 7.696H77.6335L78.7849 4.5552V7.696H78.7852ZM72.8236 7.696H74.1989L72.2223 3.21824H70.6485L68.6719 7.696H70.0153L70.3865 6.80032H72.4463L72.8236 7.696ZM72.0239 5.79616H70.8085L71.4162 4.3312L72.0239 5.79616Z",
    fill: "#006FCF"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1480_9219)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 24,
    height: 16,
    rx: 3.2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 -11.6279L76.3359 2.71484L90.6787 27.5572L115.521 13.2145L101.178 -11.6279Z",
    fill: "#E04E15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.478 -11.1103L76.6357 3.23242L90.9785 28.0748L115.821 13.732L101.478 -11.1103Z",
    fill: "#E04F15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.778 -10.5947L76.9355 3.74805L91.2783 28.5904L116.121 14.2477L101.778 -10.5947Z",
    fill: "#E15015"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.072 -10.0771L77.2295 4.26562L91.5722 29.108L116.415 14.7652L102.072 -10.0771Z",
    fill: "#E15115"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.372 -9.56149L77.5293 4.78125L91.872 29.6236L116.714 15.2809L102.372 -9.56149Z",
    fill: "#E25215"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.672 -9.04391L77.8301 5.29883L92.1728 30.1412L117.015 15.7984L102.672 -9.04391Z",
    fill: "#E25316"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.972 -8.52634L78.1299 5.81641L92.4726 30.6588L117.315 16.316L102.972 -8.52634Z",
    fill: "#E35416"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.272 -8.00876L78.4297 6.33398L92.7724 31.1763L117.615 16.8336L103.272 -8.00876Z",
    fill: "#E35516"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.572 -7.48923L78.7295 6.85352L93.0722 31.6959L117.915 17.3531L103.572 -7.48923Z",
    fill: "#E35616"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.866 -6.97555L79.0234 7.36719L93.3662 32.2095L118.209 17.8668L103.866 -6.97555Z",
    fill: "#E45716"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.166 -6.45993L79.3232 7.88281L93.666 32.7252L118.508 18.3824L104.166 -6.45993Z",
    fill: "#E45716"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.465 -5.93844L79.623 8.4043L93.9658 33.2467L118.808 18.9039L104.465 -5.93844Z",
    fill: "#E55816"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.766 -5.42282L79.9238 8.91992L94.2666 33.7623L119.109 19.4195L104.766 -5.42282Z",
    fill: "#E55916"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.059 -4.90524L80.2168 9.4375L94.5595 34.2799L119.402 19.9371L105.059 -4.90524Z",
    fill: "#E55A16"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.36 -4.38766L80.5176 9.95508L94.8603 34.7974L119.703 20.4547L105.36 -4.38766Z",
    fill: "#E65B16"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 -3.87008L80.8174 10.4727L95.1601 35.315L120.002 20.9723L105.66 -3.87008Z",
    fill: "#E65C17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.96 -3.35641L81.1172 10.9863L95.4599 35.8287L120.302 21.4859L105.96 -3.35641Z",
    fill: "#E75D17"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.253 -2.83688L81.4111 11.5059L95.7539 36.3482L120.596 22.0055L106.253 -2.83688Z",
    fill: "#E75E17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.553 -2.32126L81.7109 12.0215L96.0537 36.8638L120.896 22.5211L106.553 -2.32126Z",
    fill: "#E85F17"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.853 -1.80368L82.0107 12.5391L96.3535 37.3814L121.196 23.0387L106.853 -1.80368Z",
    fill: "#E86017"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.972 -1.60446L82.1299 12.7383L96.4726 37.5806L121.315 23.2379L106.972 -1.60446Z",
    fill: "#E86117"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.085 -1.40133L82.2422 12.9414L96.5849 37.7838L121.427 23.441L107.085 -1.40133Z",
    fill: "#E96217"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.204 -1.20212L82.3613 13.1406L96.7041 37.983L121.546 23.6402L107.204 -1.20212Z",
    fill: "#E96317"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.316 -1.0029L82.4736 13.3398L96.8164 38.1822L121.659 23.8395L107.316 -1.0029Z",
    fill: "#E96418"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.434 -0.801725L82.5918 13.541L96.9345 38.3834L121.777 24.0406L107.434 -0.801725Z",
    fill: "#E96518"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.547 -0.602509L82.7051 13.7402L97.0478 38.5826L121.89 24.2398L107.547 -0.602509Z",
    fill: "#EA6618"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.66 -0.405243L82.8174 13.9375L97.1601 38.7799L122.002 24.4371L107.66 -0.405243Z",
    fill: "#EA6718"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.778 -0.204069L82.9355 14.1387L97.2783 38.981L122.121 24.6383L107.778 -0.204069Z",
    fill: "#EA6818"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.897 -0.00289631L83.0547 14.3398L97.3974 39.1822L122.24 24.8395L107.897 -0.00289631Z",
    fill: "#EA6918"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.009 0.19632L83.167 14.5391L97.5097 39.3814L122.352 25.0387L108.009 0.19632Z",
    fill: "#EB6A18"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.122 0.39554L83.2793 14.7383L97.622 39.5806L122.464 25.2379L108.122 0.39554Z",
    fill: "#EB6B19"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.235 0.59671L83.3926 14.9395L97.7353 39.7818L122.578 25.4391L108.235 0.59671Z",
    fill: "#EB6C19"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M108.353 0.795929L83.5107 15.1387L97.8535 39.981L122.696 25.6383L108.353 0.795929Z",
    fill: "#EB6D19"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M108.472 0.99515L83.6299 15.3379L97.9726 40.1802L122.815 25.8375L108.472 0.99515Z",
    fill: "#EC6E19"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M108.585 1.19632L83.7422 15.5391L98.0849 40.3814L122.927 26.0387L108.585 1.19632Z",
    fill: "#EC6F19"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M108.697 1.39749L83.8545 15.7402L98.1972 40.5826L123.04 26.2398L108.697 1.39749Z",
    fill: "#EC7019"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.816 1.59476L83.9736 15.9375L98.3164 40.7799L123.159 26.4371L108.816 1.59476Z",
    fill: "#EC7119"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.928 1.79593L84.0859 16.1387L98.4287 40.981L123.271 26.6383L108.928 1.79593Z",
    fill: "#ED7219"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.047 1.99515L84.2051 16.3379L98.5478 41.1802L123.39 26.8375L109.047 1.99515Z",
    fill: "#ED731A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.16 2.19437L84.3174 16.5371L98.6601 41.3795L123.502 27.0367L109.16 2.19437Z",
    fill: "#ED741A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.278 2.39749L84.4355 16.7402L98.7783 41.5826L123.621 27.2398L109.278 2.39749Z",
    fill: "#ED751A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M109.391 2.59671L84.5488 16.9395L98.8916 41.7818L123.734 27.4391L109.391 2.59671Z",
    fill: "#EE761A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M109.503 2.79593L84.6611 17.1387L99.0039 41.981L123.846 27.6383L109.503 2.79593Z",
    fill: "#EE771A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M109.622 2.99515L84.7793 17.3379L99.122 42.1802L123.964 27.8375L109.622 2.99515Z",
    fill: "#EE781A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M109.741 3.19632L84.8984 17.5391L99.2412 42.3814L124.084 28.0387L109.741 3.19632Z",
    fill: "#EF791A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M109.853 3.39554L85.0107 17.7383L99.3535 42.5806L124.196 28.2379L109.853 3.39554Z",
    fill: "#EF7A1B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M109.972 3.59671L85.1299 17.9395L99.4726 42.7818L124.315 28.4391L109.972 3.59671Z",
    fill: "#EF7B1B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M110.085 3.79593L85.2422 18.1387L99.5849 42.981L124.427 28.6383L110.085 3.79593Z",
    fill: "#EF7C1B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M110.197 3.9971L85.3545 18.3398L99.6972 43.1822L124.54 28.8395L110.197 3.9971Z",
    fill: "#F07D1B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.316 4.19437L85.4736 18.5371L99.8164 43.3795L124.659 29.0367L110.316 4.19437Z",
    fill: "#F07E1B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.434 4.39554L85.5918 18.7383L99.9345 43.5806L124.777 29.2379L110.434 4.39554Z",
    fill: "#F07F1B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.547 4.59476L85.7051 18.9375L100.048 43.7799L124.89 29.4371L110.547 4.59476Z",
    fill: "#F0801B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M110.666 4.79593L85.8232 19.1387L100.166 43.981L125.008 29.6383L110.666 4.79593Z",
    fill: "#F1801C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110.778 4.99515L85.9355 19.3379L100.278 44.1802L125.121 29.8375L110.778 4.99515Z",
    fill: "#F1811C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.891 5.19632L86.0488 19.5391L100.392 44.3814L125.234 30.0387L110.891 5.19632Z",
    fill: "#F1821C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M111.009 5.39554L86.167 19.7383L100.51 44.5806L125.352 30.2379L111.009 5.39554Z",
    fill: "#F1831C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M111.128 5.59476L86.2861 19.9375L100.629 44.7799L125.471 30.4371L111.128 5.59476Z",
    fill: "#F2841C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M111.241 5.79398L86.3984 20.1367L100.741 44.9791L125.584 30.6363L111.241 5.79398Z",
    fill: "#F2851C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M111.353 5.99515L86.5107 20.3379L100.853 45.1802L125.696 30.8375L111.353 5.99515Z",
    fill: "#F2861C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M111.472 6.19437L86.6299 20.5371L100.973 45.3795L125.815 31.0367L111.472 6.19437Z",
    fill: "#F2871D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.585 6.39554L86.7422 20.7383L101.085 45.5806L125.927 31.2379L111.585 6.39554Z",
    fill: "#F3881D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M111.697 6.59085L86.8545 20.9336L101.197 45.7759L126.04 31.4332L111.697 6.59085Z",
    fill: "#F3891D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.816 6.79398L86.9736 21.1367L101.316 45.9791L126.159 31.6363L111.816 6.79398Z",
    fill: "#F38A1D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M111.934 6.9932L87.0918 21.3359L101.435 46.1783L126.277 31.8356L111.934 6.9932Z",
    fill: "#F48B1D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M112.047 7.19437L87.2051 21.5371L101.548 46.3795L126.39 32.0367L112.047 7.19437Z",
    fill: "#F48C1D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.166 7.39554L87.3232 21.7383L101.666 46.5806L126.508 32.2379L112.166 7.39554Z",
    fill: "#F48D1D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M112.278 7.59476L87.4355 21.9375L101.778 46.7799L126.621 32.4371L112.278 7.59476Z",
    fill: "#F48E1E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M112.391 7.79202L87.5488 22.1348L101.892 46.9771L126.734 32.6344L112.391 7.79202Z",
    fill: "#F58F1E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M112.509 7.9932L87.667 22.3359L102.01 47.1783L126.852 32.8356L112.509 7.9932Z",
    fill: "#F5901E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M112.628 8.19242L87.7861 22.5352L102.129 47.3775L126.971 33.0348L112.628 8.19242Z",
    fill: "#F5911E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M112.741 8.39359L87.8984 22.7363L102.241 47.5787L127.084 33.2359L112.741 8.39359Z",
    fill: "#F5921E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.86 8.59476L88.0176 22.9375L102.36 47.7799L127.203 33.4371L112.86 8.59476Z",
    fill: "#F6931E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.972 8.79398L88.1299 23.1367L102.473 47.9791L127.315 33.6363L112.972 8.79398Z",
    fill: "#F6941E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M113.085 8.99124L88.2422 23.334L102.585 48.1763L127.427 33.8336L113.085 8.99124Z",
    fill: "#F6951E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M113.204 9.19437L88.3613 23.5371L102.704 48.3795L127.546 34.0367L113.204 9.19437Z",
    fill: "#F6961F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M113.322 9.39359L88.4795 23.7363L102.822 48.5787L127.665 34.2359L113.322 9.39359Z",
    fill: "#F7971F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M113.434 9.59281L88.5918 23.9355L102.935 48.7779L127.777 34.4352L113.434 9.59281Z",
    fill: "#F7981F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M113.547 9.79398L88.7051 24.1367L103.048 48.9791L127.89 34.6363L113.547 9.79398Z",
    fill: "#F7991F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M113.666 9.99515L88.8232 24.3379L103.166 49.1802L128.008 34.8375L113.666 9.99515Z",
    fill: "#F79A1F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.778 10.1905L88.9355 24.5332L103.278 49.3756L128.121 35.0328L113.778 10.1905Z",
    fill: "#F89B1F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M113.897 10.3936L89.0547 24.7363L103.397 49.5787L128.24 35.2359L113.897 10.3936Z",
    fill: "#F89C1F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M114.009 10.5928L89.167 24.9355L103.51 49.7779L128.352 35.4352L114.009 10.5928Z",
    fill: "#F89D20"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M114.128 10.792L89.2861 25.1348L103.629 49.9771L128.471 35.6344L114.128 10.792Z",
    fill: "#F89E20"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M114.241 10.9952L89.3984 25.3379L103.741 50.1802L128.584 35.8375L114.241 10.9952Z",
    fill: "#F99F20"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M114.36 11.1944L89.5176 25.5371L103.86 50.3795L128.703 36.0367L114.36 11.1944Z",
    fill: "#F9A020"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1297 0.498074C85.6936 0.498059 84.5295 1.66234 84.5297 3.09844L84.531 12.8319C84.5312 14.2677 85.6952 15.4315 87.131 15.4315H99.3567C103.479 15.4315 106.823 12.0897 106.823 7.96487C106.823 3.84267 103.482 0.498199 99.3567 0.498199L87.1297 0.498074Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8848 6.36523H85.9922V9.48701H86.8823C87.3539 9.48701 87.6968 9.37606 87.9969 9.12642C88.3524 8.83139 88.5642 8.38758 88.5642 7.92864C88.5642 7.00825 87.8758 6.36523 86.8874 6.36523H86.8848ZM87.5959 8.71035C87.4043 8.88182 87.1572 8.95747 86.7638 8.95747H86.5999V6.89226H86.7638C87.1572 6.89226 87.3967 6.96286 87.5959 7.14442C87.8078 7.33102 87.9338 7.62353 87.9338 7.92108C87.9338 8.21863 87.8078 8.52122 87.5959 8.70782V8.71035Z",
    fill: "#261F20"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4495 6.36523H88.8418V9.48701H89.4495V6.36523Z",
    fill: "#261F20"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9405 7.56266C90.5749 7.42649 90.469 7.33823 90.469 7.16928C90.469 6.9726 90.6606 6.82382 90.9228 6.82382C91.1044 6.82382 91.2557 6.89947 91.4146 7.07598L91.7323 6.65992C91.47 6.43045 91.1574 6.31445 90.8144 6.31445C90.2622 6.31445 89.8411 6.69774 89.8411 7.20963C89.8411 7.64083 90.0378 7.86021 90.6102 8.06446C90.8472 8.14768 90.9708 8.20567 91.0313 8.24098C91.1523 8.31915 91.2128 8.43262 91.2128 8.56374C91.2128 8.81591 91.0111 9.00503 90.7388 9.00503C90.4488 9.00503 90.2143 8.85877 90.0731 8.58896L89.6797 8.9672C89.9596 9.37823 90.2975 9.56231 90.7615 9.56231C91.3944 9.56231 91.8382 9.1412 91.8382 8.53853C91.8382 8.04177 91.6339 7.81734 90.9405 7.56518V7.56266Z",
    fill: "#261F20"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0361 7.92837C92.0361 8.84624 92.7573 9.55734 93.6828 9.55734C93.945 9.55734 94.1694 9.5069 94.4468 9.37578V8.65964C94.2022 8.90423 93.9879 9.00258 93.7105 9.00258C93.0977 9.00258 92.6615 8.55877 92.6615 7.92585C92.6615 7.3257 93.1103 6.85415 93.6828 6.85415C93.9727 6.85415 94.1921 6.95754 94.4468 7.20466V6.48852C94.1795 6.35235 93.9601 6.29688 93.6979 6.29688C92.775 6.29688 92.0361 7.0231 92.0361 7.93089V7.92837Z",
    fill: "#261F20"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2713 8.46323L98.4391 6.36523H97.7734L99.0973 9.5677H99.4251L100.774 6.36523H100.114L99.2713 8.46323Z",
    fill: "#261F20"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M101.049 9.48701H102.776V8.95999H101.659V8.11777H102.736V7.58822H101.659V6.89478H102.776V6.36523H101.049V9.48701Z",
    fill: "#261F20"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M105.187 7.28758C105.187 6.70256 104.783 6.36719 104.082 6.36719H103.18V9.48896H103.787V8.23571H103.868L104.71 9.48896H105.459L104.476 8.17267C104.935 8.07937 105.187 7.76669 105.187 7.28758ZM103.966 7.80199H103.787V6.85638H103.974C104.352 6.85638 104.559 7.01525 104.559 7.32036C104.559 7.62548 104.352 7.80199 103.964 7.80199H103.966Z",
    fill: "#261F20"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M105.671 6.52909C105.671 6.47362 105.633 6.44336 105.568 6.44336H105.479V6.71822H105.545V6.61231L105.623 6.71822H105.704L105.613 6.60474C105.651 6.59466 105.674 6.56692 105.674 6.52909H105.671ZM105.555 6.56692H105.545V6.49379H105.558C105.59 6.49379 105.608 6.5064 105.608 6.52909C105.608 6.55179 105.59 6.56692 105.558 6.56692H105.555Z",
    fill: "#261F20"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M105.581 6.34375C105.448 6.34375 105.342 6.44966 105.342 6.5833C105.342 6.71695 105.45 6.82286 105.581 6.82286C105.712 6.82286 105.818 6.71443 105.818 6.5833C105.818 6.45218 105.712 6.34375 105.581 6.34375ZM105.581 6.77999C105.475 6.77999 105.39 6.69173 105.39 6.5833C105.39 6.47487 105.475 6.38662 105.581 6.38662C105.687 6.38662 105.77 6.4774 105.77 6.5833C105.77 6.68921 105.685 6.77999 105.581 6.77999Z",
    fill: "#261F20"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9529 7.92176C97.9529 8.83459 97.2141 9.57595 96.2987 9.57595C95.3834 9.57595 94.6445 8.83711 94.6445 7.92176C94.6445 7.00641 95.3834 6.26758 96.2987 6.26758C97.2141 6.26758 97.9529 7.00641 97.9529 7.92176Z",
    fill: "url(#paint0_linear_1480_9219)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    d: "M97.9529 7.92176C97.9529 8.83459 97.2141 9.57595 96.2987 9.57595C95.3834 9.57595 94.6445 8.83711 94.6445 7.92176C94.6445 7.00641 95.3834 6.26758 96.2987 6.26758C97.2141 6.26758 97.9529 7.00641 97.9529 7.92176Z",
    fill: "url(#paint1_linear_1480_9219)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1480_9219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 6,
    width: 4,
    height: 4
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9568 7.92176C97.9568 8.83459 97.2155 9.57595 96.3026 9.57595C95.3898 9.57595 94.6484 8.83711 94.6484 7.92176C94.6484 7.00641 95.3873 6.26758 96.3026 6.26758C97.218 6.26758 97.9568 7.00641 97.9568 7.92176Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1480_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3081 6.24471C97.2385 6.24471 97.995 6.99867 97.995 7.92915C97.995 8.85963 97.2385 9.61612 96.3081 9.61612C95.3776 9.61612 94.6211 8.86216 94.6211 7.92915C94.6211 6.99867 95.3751 6.24219 96.3081 6.24219V6.24471Z",
    fill: "#020000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3081 6.24609C97.2385 6.24609 97.995 6.99754 97.995 7.92802C97.995 8.8585 97.2385 9.61751 96.3081 9.61751C95.3776 9.61751 94.6211 8.86354 94.6211 7.93306C94.6211 7.00258 95.3776 6.24609 96.3081 6.24609Z",
    fill: "#030100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3114 6.25C97.2419 6.25 98.0009 7.00144 98.0009 7.93192C98.0009 8.8624 97.2444 9.62141 96.3114 9.62141C95.3784 9.62141 94.6244 8.86745 94.627 7.93697C94.627 7.00649 95.3834 6.25 96.3114 6.25252V6.25Z",
    fill: "#050100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3114 6.25001C97.2419 6.25001 98.0009 6.99893 98.0009 7.92941C98.0009 8.85989 97.2419 9.6189 96.3114 9.6189C95.3809 9.6189 94.6244 8.86493 94.627 7.93445C94.627 7.00397 95.3834 6.24748 96.3114 6.25001Z",
    fill: "#070200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3114 6.25391C97.2419 6.25391 98.0009 7.00031 98.0009 7.93079C98.0009 8.86127 97.2419 9.6228 96.3114 9.6228C95.3809 9.6228 94.6244 8.86884 94.627 7.93836C94.627 7.00788 95.3834 6.25139 96.3114 6.25391Z",
    fill: "#080200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 6.25782C97.2487 6.25782 98.0077 7.00422 98.0077 7.9347C98.0077 8.86518 97.2487 9.62671 96.3182 9.62671C95.3878 9.62671 94.6313 8.87274 94.6338 7.94226C94.6338 7.01178 95.3903 6.2553 96.3182 6.25782Z",
    fill: "#0A0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 6.25782C97.2487 6.25782 98.0103 7.0017 98.0103 7.93218C98.0103 8.86266 97.2487 9.62671 96.3182 9.62671C95.3878 9.62671 94.6313 8.87274 94.6338 7.94226C94.6338 7.01178 95.3903 6.2553 96.3182 6.25782Z",
    fill: "#0C0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 6.26034C97.2487 6.26034 98.0103 7.00422 98.0103 7.93218C98.0103 8.86014 97.2487 9.62671 96.3182 9.62671C95.3878 9.62671 94.6313 8.87274 94.6338 7.94226C94.6338 7.01178 95.3903 6.2553 96.3182 6.25782V6.26034Z",
    fill: "#0E0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 6.26368C97.2487 6.2662 98.0103 7.00504 98.0103 7.93552C98.0103 8.866 97.2462 9.63257 96.3182 9.63257C95.3903 9.63257 94.6313 8.8786 94.6338 7.94812C94.6338 7.01764 95.3903 6.26116 96.3182 6.26368Z",
    fill: "#0F0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 6.27011C97.2487 6.27263 98.0103 7.00894 98.0103 7.93942C98.0103 8.8699 97.2462 9.63648 96.3182 9.63648C95.3903 9.63648 94.6313 8.88251 94.6338 7.95203C94.6363 7.02155 95.3903 6.26506 96.3182 6.26758V6.27011Z",
    fill: "#110500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3216 6.27148C97.2521 6.27401 98.0161 7.01032 98.0161 7.93828C98.0161 8.86624 97.2521 9.63786 96.3216 9.63786C95.3911 9.63786 94.6346 8.88389 94.6397 7.95593C94.6422 7.02545 95.3962 6.26896 96.3216 6.27401V6.27148Z",
    fill: "#130500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3284 6.27539C97.2564 6.27791 98.023 7.01171 98.023 7.94219C98.023 8.87267 97.2564 9.64176 96.3284 9.64176C95.4005 9.64176 94.6415 8.8878 94.6465 7.95984C94.649 7.02936 95.403 6.27287 96.3284 6.27791V6.27539Z",
    fill: "#140600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3284 6.27542C97.2564 6.27794 98.023 7.00921 98.023 7.93969C98.023 8.87017 97.2564 9.63926 96.3284 9.63926C95.4005 9.63926 94.6415 8.8853 94.6465 7.95734C94.649 7.02686 95.4055 6.27037 96.3284 6.27542Z",
    fill: "#160600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3284 6.27932C97.2564 6.28437 98.0255 7.01311 98.0255 7.94107C98.0255 8.86903 97.2589 9.64317 96.3284 9.64317C95.3979 9.64317 94.644 8.8892 94.6465 7.96125C94.649 7.03077 95.4055 6.27428 96.3284 6.27932Z",
    fill: "#180600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3343 6.28128C97.2622 6.28632 98.0313 7.01255 98.0313 7.94303C98.0313 8.87351 97.2622 9.64512 96.3343 9.64512C95.4063 9.64512 94.6498 8.89116 94.6524 7.9632C94.6574 7.03272 95.4114 6.27623 96.3343 6.28128Z",
    fill: "#190700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3343 6.28518C97.2622 6.29022 98.0313 7.01645 98.0313 7.94441C98.0313 8.87237 97.2622 9.64903 96.3343 9.64903C95.4063 9.64903 94.6498 8.89506 94.6524 7.96711C94.6574 7.03663 95.4114 6.28014 96.3343 6.28518Z",
    fill: "#1B0700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3343 6.2877C97.2622 6.29275 98.0313 7.01645 98.0313 7.94441C98.0313 8.87237 97.2622 9.64903 96.3343 9.64903C95.4063 9.64903 94.6498 8.89759 94.6524 7.96711C94.6574 7.03663 95.4114 6.28014 96.3343 6.28518V6.2877Z",
    fill: "#1D0800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3343 6.28909C97.2622 6.29413 98.0339 7.01532 98.0339 7.9458C98.0339 8.87628 97.2622 9.65294 96.3343 9.65294C95.4063 9.65294 94.6498 8.90149 94.6524 7.97101C94.6574 7.03801 95.4114 6.28404 96.3343 6.28909Z",
    fill: "#1F0800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3376 6.29297C97.2656 6.29801 98.0372 7.0192 98.0372 7.94715C98.0372 8.87511 97.2656 9.6543 96.3376 9.6543C95.4097 9.6543 94.6532 8.90285 94.6582 7.97489C94.6633 7.04189 95.4172 6.28793 96.3376 6.29549V6.29297Z",
    fill: "#200900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.29688C97.2724 6.30192 98.044 7.02058 98.044 7.94854C98.044 8.8765 97.2724 9.6582 96.3445 9.6582C95.4165 9.6582 94.66 8.90676 94.6651 7.9788C94.6701 7.0458 95.4241 6.29183 96.3445 6.2994V6.29688Z",
    fill: "#220900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.30084C97.2724 6.30588 98.044 7.02454 98.044 7.94998C98.044 8.87542 97.2699 9.65964 96.3445 9.65964C95.419 9.65964 94.66 8.9082 94.6651 7.98024C94.6701 7.04724 95.4241 6.29327 96.3445 6.30084Z",
    fill: "#240A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.30084C97.2724 6.3084 98.0466 7.02202 98.0466 7.94998C98.0466 8.87794 97.2724 9.65964 96.3445 9.65964C95.4165 9.65964 94.66 8.9082 94.6651 7.98024C94.6701 7.04724 95.4241 6.29327 96.3445 6.30084Z",
    fill: "#250A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.30474C97.2724 6.31231 98.0466 7.02341 98.0466 7.95137C98.0466 8.87932 97.2724 9.66355 96.3445 9.66355C95.4165 9.66355 94.66 8.9121 94.6651 7.98415C94.6701 7.05114 95.4266 6.29718 96.3445 6.30474Z",
    fill: "#270B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.30723C97.2724 6.3148 98.0466 7.0259 98.0466 7.95133C98.0466 8.87677 97.2699 9.66352 96.3445 9.66352C95.419 9.66352 94.66 8.91207 94.6651 7.98411C94.6701 7.05111 95.4266 6.29967 96.3445 6.30471V6.30723Z",
    fill: "#290B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.31057C97.2724 6.31814 98.0491 7.02671 98.0491 7.95467C98.0491 8.88263 97.2724 9.66938 96.3445 9.66938C95.4165 9.66938 94.66 8.91793 94.6651 7.98998C94.6726 7.05697 95.4266 6.30553 96.3445 6.31057Z",
    fill: "#2A0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3445 6.31309C97.2724 6.32066 98.0491 7.02671 98.0491 7.95467C98.0491 8.88263 97.2724 9.66938 96.3445 9.66938C95.4165 9.66938 94.66 8.91793 94.6651 7.98998C94.6726 7.05697 95.4266 6.30553 96.3445 6.31057V6.31309Z",
    fill: "#2C0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3503 6.31448C97.2758 6.32204 98.0549 7.0281 98.0549 7.95354C98.0549 8.87897 97.2758 9.67076 96.3503 9.67076C95.4249 9.67076 94.6659 8.91932 94.6709 7.99388C94.6785 7.06088 95.4325 6.30944 96.3503 6.31448Z",
    fill: "#2E0D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3478 6.31836C97.2733 6.32592 98.0525 7.02946 98.0525 7.95742C98.0525 8.88537 97.2733 9.67464 96.3478 9.67464C95.4224 9.67464 94.6634 8.9232 94.671 7.99776C94.6785 7.06476 95.4325 6.31332 96.3478 6.32088V6.31836Z",
    fill: "#300D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3547 6.32227C97.2801 6.32983 98.0618 7.03336 98.0618 7.9588C98.0618 8.88424 97.2826 9.67855 96.3547 9.67855C95.4267 9.67855 94.6702 8.9271 94.6778 8.00167C94.6854 7.06867 95.4393 6.31722 96.3547 6.32479V6.32227Z",
    fill: "#310D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3547 6.32428C97.2801 6.33184 98.0618 7.03285 98.0618 7.95829C98.0618 8.88373 97.2801 9.67804 96.3547 9.67804C95.4292 9.67804 94.6702 8.92659 94.6778 8.00116C94.6854 7.06816 95.4393 6.31671 96.3547 6.32428Z",
    fill: "#330E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3547 6.32818C97.2801 6.33827 98.0618 7.03424 98.0618 7.9622C98.0618 8.89015 97.2801 9.68194 96.3547 9.68194C95.4292 9.68194 94.6702 8.9305 94.6778 8.00506C94.6854 7.07206 95.4393 6.32062 96.3547 6.32818Z",
    fill: "#350E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3547 6.33013C97.2801 6.34022 98.0643 7.03619 98.0643 7.96163C98.0643 8.88706 97.2826 9.6839 96.3547 9.6839C95.4267 9.6839 94.6702 8.93245 94.6778 8.00702C94.6854 7.07401 95.4393 6.32257 96.3547 6.33013Z",
    fill: "#360F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3605 6.33266C97.286 6.34274 98.0702 7.03619 98.0702 7.96163C98.0702 8.88706 97.286 9.6839 96.3605 9.6839C95.4351 9.6839 94.6761 8.93245 94.6836 8.00702C94.6912 7.07401 95.4452 6.32257 96.3605 6.33013V6.33266Z",
    fill: "#380F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3605 6.33599C97.286 6.34608 98.0702 7.03953 98.0702 7.96496C98.0702 8.8904 97.286 9.68976 96.3605 9.68976C95.4351 9.68976 94.6761 8.93831 94.6836 8.01288C94.6912 7.07987 95.4477 6.32843 96.3605 6.33599Z",
    fill: "#3A1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3605 6.33852C97.286 6.3486 98.0702 7.03953 98.0702 7.96496C98.0702 8.8904 97.286 9.68976 96.3605 9.68976C95.4351 9.68976 94.6761 8.93831 94.6836 8.01288C94.6937 7.07987 95.4477 6.32843 96.3605 6.33599V6.33852Z",
    fill: "#3B1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3639 6.33984C97.2893 6.34993 98.0761 7.03833 98.0761 7.96377C98.0761 8.88921 97.2893 9.69108 96.3639 9.69108C95.4385 9.69108 94.6795 8.93964 94.6896 8.01673C94.6996 7.08372 95.4536 6.33228 96.3639 6.34237V6.33984Z",
    fill: "#3D1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3707 6.34375C97.2962 6.35384 98.0829 7.04224 98.0829 7.96768C98.0829 8.89311 97.2962 9.69499 96.3707 9.69499C95.4453 9.69499 94.6863 8.94607 94.6964 8.02063C94.7065 7.08763 95.4604 6.33618 96.3707 6.34627V6.34375Z",
    fill: "#3F1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3707 6.34385C97.2962 6.35394 98.0829 7.03982 98.0829 7.96526C98.0829 8.89069 97.2962 9.69257 96.3707 9.69257C95.4453 9.69257 94.6863 8.94365 94.6964 8.01821C94.7065 7.08521 95.4604 6.33376 96.3707 6.34385Z",
    fill: "#411200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3707 6.34971C97.2962 6.3598 98.0829 7.04316 98.0829 7.96859C98.0829 8.89403 97.2937 9.69843 96.3707 9.69843C95.4478 9.69843 94.6863 8.94951 94.6964 8.02407C94.7065 7.09107 95.4604 6.33962 96.3707 6.34971Z",
    fill: "#421200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3707 6.35166C97.2962 6.36427 98.0855 7.04511 98.0855 7.97055C98.0855 8.89598 97.2962 9.70038 96.3707 9.70038C95.4453 9.70038 94.6863 8.95146 94.6964 8.02602C94.7065 7.09302 95.4604 6.34158 96.3707 6.35166Z",
    fill: "#441300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3766 6.35557C97.302 6.36818 98.0913 7.0465 98.0913 7.97193C98.0913 8.89737 97.302 9.70429 96.3766 9.70429C95.4512 9.70429 94.6922 8.95537 94.7022 8.02993C94.7123 7.09693 95.4663 6.34548 96.3766 6.35557Z",
    fill: "#461300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3766 6.35809C97.2995 6.3707 98.0913 7.04902 98.0913 7.97193C98.0913 8.89485 97.2995 9.70429 96.3766 9.70429C95.4537 9.70429 94.6922 8.95537 94.7022 8.02993C94.7123 7.09693 95.4663 6.34548 96.3766 6.35557V6.35809Z",
    fill: "#471300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3766 6.35948C97.2995 6.37208 98.0938 7.04788 98.0938 7.97331C98.0938 8.89875 97.302 9.70819 96.3766 9.70819C95.4512 9.70819 94.6922 8.95927 94.7022 8.03383C94.7123 7.10083 95.4663 6.34939 96.3766 6.35948Z",
    fill: "#491400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3834 6.36328C97.3064 6.37589 98.1007 7.04916 98.1007 7.9746C98.1007 8.90004 97.3089 9.70948 96.3834 9.70948C95.458 9.70948 94.699 8.96056 94.7091 8.03764C94.7217 7.10464 95.4731 6.3532 96.3834 6.3658V6.36328Z",
    fill: "#4B1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.381 6.36523C97.3039 6.37784 98.0982 7.05112 98.0982 7.97403C98.0982 8.89695 97.3039 9.71143 96.381 9.71143C95.4581 9.71143 94.6965 8.96251 94.7091 8.03959C94.7217 7.10659 95.4757 6.35515 96.381 6.36776V6.36523Z",
    fill: "#4C1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3868 6.36734C97.3098 6.37995 98.1041 7.0507 98.1041 7.97362C98.1041 8.89653 97.3098 9.71102 96.3868 9.71102C95.4639 9.71102 94.7024 8.9621 94.715 8.03918C94.7276 7.10618 95.4816 6.35474 96.3868 6.36734Z",
    fill: "#4E1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3868 6.3693C97.3098 6.38191 98.1066 7.05266 98.1066 7.97557C98.1066 8.89849 97.3123 9.71297 96.3868 9.71297C95.4614 9.71297 94.7024 8.96405 94.715 8.04114C94.7276 7.10813 95.4816 6.35669 96.3868 6.3693Z",
    fill: "#501600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3868 6.37516C97.3098 6.38776 98.1066 7.056 98.1066 7.97891C98.1066 8.90183 97.3098 9.71883 96.3868 9.71883C95.4639 9.71883 94.7024 8.96991 94.715 8.04699C94.7276 7.11399 95.4816 6.36255 96.3868 6.37516Z",
    fill: "#521600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3868 6.37768C97.3098 6.39281 98.1066 7.056 98.1066 7.97891C98.1066 8.90183 97.3098 9.71883 96.3868 9.71883C95.4639 9.71883 94.7024 8.96991 94.715 8.04699C94.7276 7.11399 95.4816 6.36255 96.3868 6.37516V6.37768Z",
    fill: "#531700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3927 6.37906C97.3156 6.39419 98.1124 7.05738 98.1124 7.9803C98.1124 8.90321 97.3156 9.72274 96.3927 9.72274C95.4698 9.72274 94.7082 8.97382 94.7209 8.0509C94.7335 7.1179 95.4874 6.36645 96.3927 6.37906Z",
    fill: "#551700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3927 6.38158C97.3156 6.39671 98.115 7.05738 98.115 7.9803C98.115 8.90321 97.3156 9.72274 96.3927 9.72274C95.4698 9.72274 94.7082 8.97382 94.7209 8.0509C94.7335 7.1179 95.4874 6.36645 96.3927 6.37906V6.38158Z",
    fill: "#571800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3927 6.38549C97.3156 6.40062 98.115 7.05877 98.115 7.98168C98.115 8.9046 97.3156 9.72665 96.3927 9.72665C95.4698 9.72665 94.7082 8.97772 94.7209 8.05481C94.7335 7.1218 95.4874 6.37036 96.3927 6.38297V6.38549Z",
    fill: "#581800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3971 6.38672C97.32 6.40185 98.1193 7.05999 98.1193 7.98291C98.1193 8.90582 97.32 9.72787 96.3971 9.72787C95.4742 9.72787 94.7126 8.97895 94.7278 8.05856C94.7404 7.12556 95.4943 6.37411 96.3971 6.38924V6.38672Z",
    fill: "#5A1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4029 6.39062C97.3259 6.40575 98.1277 7.06138 98.1277 7.98429C98.1277 8.90721 97.3259 9.73178 96.4029 9.73178C95.48 9.73178 94.7185 8.98286 94.7336 8.06246C94.7487 7.12946 95.5002 6.37802 96.4029 6.39315V6.39062Z",
    fill: "#5C1900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4029 6.3928C97.3259 6.40793 98.1277 7.06355 98.1277 7.98395C98.1277 8.90434 97.3259 9.73143 96.4029 9.73143C95.48 9.73143 94.7185 8.98251 94.7336 8.06212C94.7487 7.12912 95.5027 6.37767 96.4029 6.3928Z",
    fill: "#5E1A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4029 6.39476C97.3259 6.40989 98.1277 7.06299 98.1277 7.9859C98.1277 8.90882 97.3259 9.73339 96.4029 9.73339C95.48 9.73339 94.7185 8.98699 94.7336 8.06407C94.7487 7.13107 95.5027 6.37963 96.4029 6.39476Z",
    fill: "#5F1A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4029 6.39866C97.3233 6.41379 98.1277 7.06437 98.1277 7.98729C98.1277 8.9102 97.3233 9.7373 96.4029 9.7373C95.4825 9.7373 94.7185 8.99089 94.7336 8.06798C94.7487 7.13498 95.5027 6.38353 96.4029 6.39866Z",
    fill: "#611A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4098 6.40314C97.3302 6.42079 98.1371 7.06885 98.1371 7.98924C98.1371 8.90963 97.3327 9.73925 96.4098 9.73925C95.4869 9.73925 94.7253 8.99285 94.7405 8.06993C94.7556 7.13693 95.5096 6.38549 96.4098 6.40062V6.40314Z",
    fill: "#631B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4098 6.40647C97.3302 6.42413 98.1371 7.06966 98.1371 7.99258C98.1371 8.91549 97.3302 9.74511 96.4098 9.74511C95.4894 9.74511 94.7253 8.9987 94.7405 8.07579C94.7556 7.14279 95.5096 6.39134 96.4098 6.40647Z",
    fill: "#641B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4098 6.40899C97.3302 6.42665 98.1371 7.07218 98.1371 7.99258C98.1371 8.91297 97.3302 9.74511 96.4098 9.74511C95.4894 9.74511 94.7253 8.9987 94.7405 8.07579C94.7556 7.14279 95.5095 6.39134 96.4098 6.40647V6.40899Z",
    fill: "#661C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4132 6.41016C97.3336 6.42781 98.1405 7.07082 98.1405 7.99121C98.1405 8.91161 97.3336 9.74627 96.4132 9.74627C95.4928 9.74627 94.7287 8.99987 94.7464 8.07947C94.7615 7.14647 95.5155 6.39503 96.4132 6.41268V6.41016Z",
    fill: "#681C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.419 6.41211C97.3394 6.42976 98.1489 7.07025 98.1489 7.99317C98.1489 8.91608 97.3394 9.74822 96.419 9.74822C95.4987 9.74822 94.7346 9.00182 94.7523 8.08142C94.7674 7.14842 95.5213 6.39698 96.419 6.41463V6.41211Z",
    fill: "#691D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.419 6.41602C97.3394 6.43367 98.1489 7.07416 98.1489 7.99455C98.1489 8.91495 97.3394 9.75213 96.419 9.75213C95.4987 9.75213 94.7346 9.00573 94.7523 8.08533C94.7674 7.15233 95.5213 6.40089 96.419 6.41854V6.41602Z",
    fill: "#6B1D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.419 6.41827C97.3394 6.43592 98.1489 7.0739 98.1489 7.99429C98.1489 8.91468 97.3394 9.75186 96.419 9.75186C95.4987 9.75186 94.7346 9.00546 94.7523 8.08507C94.7699 7.15207 95.5213 6.40062 96.419 6.41827Z",
    fill: "#6D1E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.419 6.42023C97.3394 6.43788 98.1514 7.07333 98.1514 7.99624C98.1514 8.91916 97.3394 9.75382 96.419 9.75382C95.4987 9.75382 94.7346 9.00741 94.7523 8.08702C94.7699 7.15402 95.5213 6.40258 96.419 6.42023Z",
    fill: "#6F1E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.419 6.42413C97.3394 6.44431 98.1514 7.07723 98.1514 7.99763C98.1514 8.91802 97.3394 9.75772 96.419 9.75772C95.4987 9.75772 94.7346 9.01132 94.7523 8.09093C94.7699 7.15792 95.5239 6.40648 96.419 6.42413Z",
    fill: "#701F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4258 6.42665C97.3462 6.44683 98.1582 7.07723 98.1582 7.99763C98.1582 8.91802 97.3462 9.75772 96.4258 9.75772C95.5054 9.75772 94.7439 9.01132 94.759 8.09093C94.7767 7.15792 95.5306 6.40648 96.4258 6.42413V6.42665Z",
    fill: "#721F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4258 6.42999C97.3462 6.45017 98.1582 7.08057 98.1582 8.00096C98.1582 8.92136 97.3437 9.76358 96.4258 9.76358C95.5079 9.76358 94.7439 9.01718 94.759 8.09679C94.7767 7.16379 95.5306 6.41234 96.4258 6.42999Z",
    fill: "#742000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4317 6.43399C97.3521 6.45416 98.1665 7.08205 98.1665 8.00244C98.1665 8.92284 97.3521 9.76506 96.4317 9.76506C95.5113 9.76506 94.7497 9.01866 94.7649 8.09827C94.7825 7.16526 95.5365 6.41382 96.4317 6.43399Z",
    fill: "#752000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4292 6.4375C97.3496 6.45767 98.1641 7.08304 98.1641 8.00343C98.1641 8.92382 97.3496 9.76857 96.4292 9.76857C95.5088 9.76857 94.7473 9.02217 94.7649 8.10429C94.7826 7.17129 95.5366 6.41985 96.4292 6.44002V6.4375Z",
    fill: "#772000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4361 6.4379C97.3565 6.45807 98.1709 7.08343 98.1709 8.0013C98.1709 8.91918 97.3539 9.76644 96.4361 9.76644C95.5182 9.76644 94.7541 9.02004 94.7718 8.10217C94.7894 7.16917 95.5434 6.41772 96.4361 6.4379Z",
    fill: "#792100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4361 6.4418C97.3539 6.46198 98.1735 7.08482 98.1735 8.00521C98.1735 8.9256 97.3565 9.77035 96.4361 9.77035C95.5157 9.77035 94.7541 9.02395 94.7718 8.10608C94.7894 7.17307 95.5434 6.42163 96.4361 6.4418Z",
    fill: "#7A2100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4361 6.4418C97.3539 6.46198 98.1735 7.08482 98.1735 8.00269C98.1735 8.92056 97.3565 9.77035 96.4361 9.77035C95.5157 9.77035 94.7541 9.02395 94.7718 8.10608C94.792 7.17308 95.5434 6.42163 96.4361 6.4418Z",
    fill: "#7C2200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4361 6.44433C97.3539 6.4645 98.1735 7.08482 98.1735 8.00269C98.1735 8.92056 97.3539 9.77035 96.4361 9.77035C95.5182 9.77035 94.7541 9.02395 94.7718 8.10608C94.792 7.17308 95.5434 6.42163 96.4361 6.4418V6.44433Z",
    fill: "#7E2200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4419 6.44962C97.3598 6.47231 98.1793 7.08759 98.1793 8.00798C98.1793 8.92837 97.3598 9.77816 96.4419 9.77816C95.524 9.77816 94.76 9.03428 94.7776 8.11389C94.7978 7.18089 95.5493 6.42944 96.4419 6.44962Z",
    fill: "#802300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4419 6.45214C97.3598 6.47483 98.1818 7.09011 98.1818 8.00798C98.1818 8.92585 97.3623 9.77816 96.4419 9.77816C95.5215 9.77816 94.76 9.03428 94.7776 8.11389C94.7978 7.18089 95.5493 6.42944 96.4419 6.44962V6.45214Z",
    fill: "#812300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4419 6.45604C97.3598 6.47874 98.1818 7.09149 98.1818 8.00936C98.1818 8.92724 97.3598 9.78207 96.4419 9.78207C95.524 9.78207 94.76 9.03819 94.7776 8.11779C94.7978 7.18479 95.5518 6.43335 96.4419 6.45352V6.45604Z",
    fill: "#832400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4453 6.45898C97.3632 6.48168 98.1853 7.09443 98.1853 8.0123C98.1853 8.93018 97.3632 9.78501 96.4453 9.78501C95.5275 9.78501 94.7634 9.04113 94.7836 8.12326C94.8038 7.19026 95.5577 6.43881 96.4453 6.4615V6.45898Z",
    fill: "#852400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4453 6.46094C97.3632 6.48363 98.1853 7.09387 98.1853 8.01174C98.1853 8.92961 97.3632 9.78696 96.4453 9.78696C95.5275 9.78696 94.7634 9.04308 94.7836 8.12521C94.8038 7.19221 95.5577 6.44077 96.4453 6.46346V6.46094Z",
    fill: "#862500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4453 6.46339C97.3632 6.48609 98.1878 7.0938 98.1878 8.01167C98.1878 8.92954 97.3632 9.78689 96.4453 9.78689C95.5275 9.78689 94.7634 9.04302 94.7836 8.12514C94.8038 7.19214 95.5577 6.4407 96.4453 6.46339Z",
    fill: "#882500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4453 6.46534C97.3632 6.48804 98.1878 7.09575 98.1878 8.01362C98.1878 8.93149 97.3632 9.78885 96.4453 9.78885C95.5275 9.78885 94.7634 9.04497 94.7836 8.1271C94.8038 7.19409 95.5577 6.44265 96.4453 6.46534Z",
    fill: "#8A2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4453 6.46925C97.3632 6.49195 98.1878 7.09714 98.1878 8.01501C98.1878 8.93288 97.3632 9.79275 96.4453 9.79275C95.5275 9.79275 94.7634 9.04887 94.7836 8.131C94.8038 7.198 95.5577 6.44656 96.4453 6.46925Z",
    fill: "#8B2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4522 6.47177C97.3701 6.49447 98.1971 7.09714 98.1971 8.01501C98.1971 8.93288 97.3701 9.79275 96.4522 9.79275C95.5343 9.79275 94.7703 9.04887 94.7904 8.131C94.8131 7.198 95.5646 6.44656 96.4522 6.46925V6.47177Z",
    fill: "#8D2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4522 6.47316C97.3701 6.49837 98.1971 7.09852 98.1971 8.01639C98.1971 8.93426 97.3701 9.79666 96.4522 9.79666C95.5343 9.79666 94.7703 9.05278 94.7904 8.13491C94.8131 7.20191 95.5646 6.45046 96.4522 6.47316Z",
    fill: "#8F2700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4522 6.47568C97.3701 6.5009 98.1971 7.09852 98.1971 8.01639C98.1971 8.93426 97.3701 9.79666 96.4522 9.79666C95.5343 9.79666 94.7703 9.05278 94.7904 8.13491C94.8131 7.20191 95.5646 6.45046 96.4522 6.47316V6.47568Z",
    fill: "#912700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4556 6.47852C97.371 6.50373 98.2006 7.10136 98.2006 8.01671C98.2006 8.93206 97.371 9.7995 96.4556 9.7995C95.5403 9.7995 94.7737 9.05562 94.7964 8.14027C94.8191 7.20727 95.5705 6.45582 96.4556 6.48104V6.47852Z",
    fill: "#922800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4556 6.48438C97.371 6.50959 98.2031 7.10469 98.2031 8.02257C98.2031 8.94044 97.3735 9.80536 96.4556 9.80536C95.5377 9.80536 94.7737 9.06148 94.7964 8.14613C94.8191 7.21312 95.5731 6.46168 96.4556 6.4869V6.48438Z",
    fill: "#942800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4556 6.48438C97.371 6.50959 98.2031 7.10217 98.2031 8.02004C98.2031 8.93792 97.3735 9.80536 96.4556 9.80536C95.5377 9.80536 94.7737 9.06148 94.7964 8.14613C94.8191 7.21312 95.5731 6.46168 96.4556 6.4869V6.48438Z",
    fill: "#962900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4625 6.4889C97.3778 6.51411 98.2099 7.1067 98.2099 8.02205C98.2099 8.9374 97.3778 9.80736 96.4625 9.80736C95.5471 9.80736 94.7805 9.06348 94.8032 8.14813C94.8259 7.21513 95.5799 6.46368 96.4625 6.4889Z",
    fill: "#972900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4625 6.49085C97.3778 6.51607 98.2099 7.10613 98.2099 8.024C98.2099 8.94187 97.3778 9.80931 96.4625 9.80931C95.5471 9.80931 94.7805 9.06543 94.8032 8.15008C94.8259 7.21708 95.5799 6.46563 96.4625 6.49085Z",
    fill: "#992A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4625 6.4928C97.3778 6.51802 98.2125 7.10808 98.2125 8.02343C98.2125 8.93878 97.3803 9.81126 96.4625 9.81126C95.5446 9.81126 94.7805 9.06738 94.8032 8.15203C94.8259 7.21903 95.5799 6.46759 96.4625 6.4928Z",
    fill: "#9B2A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4683 6.49532C97.3837 6.52054 98.2183 7.10808 98.2183 8.02343C98.2183 8.93878 97.3837 9.81126 96.4683 9.81126C95.553 9.81126 94.7864 9.06738 94.8091 8.15203C94.8318 7.21903 95.5857 6.46759 96.4683 6.4928V6.49532Z",
    fill: "#9C2B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4683 6.49866C97.3837 6.5264 98.2183 7.1089 98.2183 8.02677C98.2183 8.94464 97.3837 9.81712 96.4683 9.81712C95.553 9.81712 94.7864 9.07324 94.8091 8.15789C94.8343 7.22489 95.5857 6.47345 96.4683 6.49866Z",
    fill: "#9E2B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4683 6.50119C97.3837 6.52892 98.2208 7.11142 98.2208 8.02677C98.2208 8.94212 97.3862 9.81712 96.4683 9.81712C95.5504 9.81712 94.7864 9.07324 94.8091 8.15789C94.8343 7.22489 95.5857 6.47345 96.4683 6.49866V6.50119Z",
    fill: "#A02C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4718 6.50391C97.3871 6.53164 98.2243 7.11162 98.2243 8.02697C98.2243 8.94232 97.3871 9.81984 96.4718 9.81984C95.5564 9.81984 94.7898 9.07848 94.8151 8.16313C94.8403 7.23013 95.5917 6.47869 96.4718 6.50643V6.50391Z",
    fill: "#A22C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4718 6.5066C97.3871 6.53434 98.2243 7.11179 98.2243 8.02714C98.2243 8.94249 97.3871 9.82002 96.4718 9.82002C95.5564 9.82002 94.7898 9.07866 94.8151 8.16331C94.8403 7.23031 95.5917 6.47887 96.4718 6.5066Z",
    fill: "#A32D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4786 6.51172C97.394 6.53946 98.2311 7.11691 98.2311 8.03226C98.2311 8.94761 97.394 9.82766 96.4786 9.82766C95.5633 9.82766 94.7967 9.0863 94.8219 8.17095C94.8471 7.23795 95.5986 6.4865 96.4786 6.51424V6.51172Z",
    fill: "#A52D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4786 6.51442C97.394 6.54215 98.2337 7.11709 98.2337 8.03244C98.2337 8.94779 97.394 9.82783 96.4786 9.82783C95.5633 9.82783 94.7967 9.08648 94.8219 8.17113C94.8471 7.23812 95.6011 6.48668 96.4786 6.51442Z",
    fill: "#A72D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4786 6.51694C97.394 6.54468 98.2337 7.11961 98.2337 8.03244C98.2337 8.94526 97.394 9.82783 96.4786 9.82783C95.5633 9.82783 94.7967 9.08648 94.8219 8.17113C94.8471 7.23812 95.6011 6.48668 96.4786 6.51442V6.51694Z",
    fill: "#A82E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4845 6.51832C97.3998 6.54606 98.2395 7.11847 98.2395 8.03382C98.2395 8.94917 97.3998 9.83174 96.4845 9.83174C95.5691 9.83174 94.8025 9.09038 94.8278 8.17503C94.853 7.24203 95.6069 6.49058 96.4845 6.51832Z",
    fill: "#AA2E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4845 6.52084C97.3973 6.54858 98.2395 7.11847 98.2395 8.03382C98.2395 8.94917 97.3973 9.83174 96.4845 9.83174C95.5716 9.83174 94.8025 9.09038 94.8278 8.17503C94.853 7.24203 95.6069 6.49058 96.4845 6.51832V6.52084Z",
    fill: "#AC2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4845 6.52475C97.3973 6.55501 98.242 7.12238 98.242 8.0352C98.242 8.94803 97.3998 9.83564 96.4845 9.83564C95.5691 9.83564 94.8025 9.09429 94.8278 8.17894C94.853 7.24593 95.6069 6.49449 96.4845 6.52223V6.52475Z",
    fill: "#AD2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4889 6.52734C97.4017 6.5576 98.2465 7.12245 98.2465 8.0378C98.2465 8.95315 97.4043 9.83824 96.4889 9.83824C95.5736 9.83824 94.807 9.09688 94.8347 8.18405C94.8625 7.25105 95.6139 6.49961 96.4889 6.52987V6.52734Z",
    fill: "#AF3000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4889 6.52734C97.4017 6.5576 98.2465 7.12245 98.2465 8.03527C98.2465 8.9481 97.4017 9.83824 96.4889 9.83824C95.5761 9.83824 94.807 9.09688 94.8347 8.18405C94.8624 7.25105 95.6139 6.49961 96.4889 6.52987V6.52734Z",
    fill: "#B13000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4889 6.53213C97.4017 6.56239 98.249 7.12471 98.249 8.03754C98.249 8.95037 97.4043 9.8405 96.4889 9.8405C95.5736 9.8405 94.807 9.09915 94.8347 8.18632C94.8625 7.25332 95.6139 6.50187 96.4889 6.53213Z",
    fill: "#B33100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4948 6.53604C97.4076 6.5663 98.2549 7.1261 98.2549 8.04145C98.2549 8.9568 97.4101 9.84441 96.4948 9.84441C95.5794 9.84441 94.8128 9.10305 94.8406 8.19023C94.8683 7.25722 95.6198 6.50578 96.4948 6.53604Z",
    fill: "#B43100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4948 6.53995C97.4076 6.5702 98.2549 7.13001 98.2549 8.04283C98.2549 8.95566 97.4076 9.84832 96.4948 9.84832C95.5819 9.84832 94.8128 9.10696 94.8406 8.19413C94.8683 7.26113 95.6198 6.50969 96.4948 6.53995Z",
    fill: "#B63200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4948 6.54247C97.4076 6.57273 98.2549 7.13001 98.2549 8.04283C98.2549 8.95566 97.4076 9.84832 96.4948 9.84832C95.5819 9.84832 94.8128 9.10696 94.8406 8.19413C94.8683 7.26113 95.6198 6.50969 96.4948 6.53995V6.54247Z",
    fill: "#B83200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5006 6.54385C97.4134 6.57411 98.2632 7.12887 98.2632 8.04422C98.2632 8.95957 97.4134 9.85223 96.5006 9.85223C95.5878 9.85223 94.8187 9.11087 94.8464 8.19804C94.8742 7.26252 95.6281 6.51359 96.5006 6.54385Z",
    fill: "#B93300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2632 8.04422C98.2632 8.95705 97.4134 9.85223 96.5006 9.85223C95.5878 9.85223 94.8187 9.11087 94.8464 8.19804C94.8742 7.26252 95.6281 6.51359 96.5006 6.54385C97.4134 6.57664 98.2632 7.12887 98.2632 8.0417V8.04422Z",
    fill: "#BB3300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M96.5006 6.54957C97.4134 6.57983 98.2632 7.13459 98.2632 8.04994C98.2632 8.96529 97.416 9.85795 96.5006 9.85795C95.5853 9.85795 94.8187 9.11659 94.8464 8.20376C94.8742 7.27076 95.6281 6.52184 96.5006 6.54957Z",
    fill: "#BC3502"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M96.5073 6.55209C97.4202 6.58235 98.2674 7.13963 98.2674 8.05246C98.2674 8.96529 97.4202 9.85795 96.5073 9.85795C95.5945 9.85795 94.8279 9.11659 94.8531 8.20376C94.8809 7.27076 95.6323 6.52184 96.5073 6.54957V6.55209Z",
    fill: "#BC3705"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M96.5073 6.55153C97.4202 6.58179 98.2674 7.14159 98.2674 8.05442C98.2674 8.96724 97.4202 9.8599 96.5073 9.8599C95.5945 9.8599 94.8279 9.11854 94.8531 8.20572C94.8809 7.27271 95.6323 6.52379 96.5073 6.55153Z",
    fill: "#BD3907"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M96.5073 6.55405C97.4202 6.58431 98.2649 7.14411 98.2649 8.05694C98.2649 8.96977 97.4202 9.8599 96.5073 9.8599C95.5945 9.8599 94.8279 9.11854 94.8531 8.20572C94.8809 7.27271 95.6323 6.52379 96.5073 6.55153V6.55405Z",
    fill: "#BD3A09"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M96.5073 6.55796C97.4202 6.58822 98.2649 7.15054 98.2649 8.06337C98.2649 8.9762 97.4202 9.86381 96.5073 9.86381C95.5945 9.86381 94.8279 9.12245 94.8531 8.20962C94.8809 7.27662 95.6323 6.5277 96.5073 6.55543V6.55796Z",
    fill: "#BE3C0C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M96.5073 6.55991C97.4202 6.59017 98.2649 7.15249 98.2649 8.06532C98.2649 8.97815 97.4227 9.86576 96.5073 9.86576C95.592 9.86576 94.8279 9.1244 94.8531 8.21157C94.8809 7.27857 95.6323 6.52965 96.5073 6.55739V6.55991Z",
    fill: "#BF3E0E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M96.5132 6.56186C97.426 6.59212 98.2682 7.15697 98.2682 8.0698C98.2682 8.98262 97.426 9.86771 96.5132 9.86771C95.6004 9.86771 94.8338 9.12636 94.859 8.21353C94.8867 7.28053 95.6382 6.5316 96.5132 6.55934V6.56186Z",
    fill: "#BF4010"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M96.5132 6.56382C97.426 6.59407 98.2682 7.15892 98.2682 8.07175C98.2682 8.98457 97.426 9.86967 96.5132 9.86967C95.6004 9.86967 94.8338 9.12831 94.859 8.21548C94.8842 7.28248 95.6357 6.53356 96.5132 6.56129V6.56382Z",
    fill: "#C04213"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M96.5132 6.56382C97.426 6.59155 98.2657 7.16144 98.2657 8.07427C98.2657 8.9871 97.426 9.86967 96.5132 9.86967C95.6004 9.86967 94.8338 9.12831 94.859 8.21548C94.8842 7.28248 95.6357 6.53356 96.5132 6.56129V6.56382Z",
    fill: "#C14415"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M96.5132 6.56703C97.426 6.59476 98.2657 7.16465 98.2657 8.08C98.2657 8.99535 97.426 9.8754 96.5132 9.8754C95.6004 9.8754 94.8338 9.13404 94.859 8.22121C94.8842 7.28821 95.6357 6.54181 96.5132 6.56703Z",
    fill: "#C14617"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M96.52 6.56955C97.4329 6.59728 98.2726 7.16969 98.2726 8.08252C98.2726 8.99535 97.4329 9.8754 96.52 9.8754C95.6072 9.8754 94.8406 9.13404 94.8658 8.22121C94.8911 7.28821 95.6425 6.54181 96.52 6.56703V6.56955Z",
    fill: "#C24719"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M96.5199 6.57289C97.4327 6.60062 98.2699 7.17556 98.2699 8.08838C98.2699 9.00121 97.4327 9.88126 96.5199 9.88126C95.6071 9.88126 94.843 9.1399 94.8657 8.22707C94.8909 7.29407 95.6424 6.54767 96.5199 6.57289Z",
    fill: "#C2491C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M96.5199 6.57541C97.4327 6.60315 98.2699 7.17808 98.2699 8.0909C98.2699 9.00373 97.4327 9.88126 96.5199 9.88126C95.6071 9.88126 94.843 9.1399 94.8657 8.22707C94.8909 7.29407 95.6424 6.54767 96.5199 6.57289V6.57541Z",
    fill: "#C34B1E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M96.5258 6.5754C97.4386 6.60314 98.2733 7.1806 98.2733 8.09342C98.2733 9.00625 97.4386 9.88126 96.5258 9.88126C95.6129 9.88126 94.8489 9.1399 94.8716 8.22707C94.8968 7.29659 95.6482 6.54767 96.5258 6.57288V6.5754Z",
    fill: "#C44D20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M96.5258 6.57931C97.4386 6.60705 98.2733 7.1845 98.2733 8.09733C98.2733 9.01016 97.4386 9.88516 96.5258 9.88516C95.6129 9.88516 94.8489 9.14381 94.8716 8.23098C94.8968 7.3005 95.6457 6.55157 96.5258 6.57679V6.57931Z",
    fill: "#C44F23"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M96.5258 6.57931C97.4386 6.60705 98.2733 7.18702 98.2733 8.09985C98.2733 9.01268 97.4386 9.88516 96.5258 9.88516C95.6129 9.88516 94.8489 9.14381 94.8716 8.23098C94.8968 7.3005 95.6457 6.55157 96.5258 6.57679V6.57931Z",
    fill: "#C55125"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M96.5258 6.58127C97.4386 6.609 98.2707 7.18898 98.2707 8.10181C98.2707 9.01463 97.4386 9.88712 96.5258 9.88712C95.6129 9.88712 94.8489 9.14576 94.8716 8.23293C94.8968 7.30245 95.6457 6.55353 96.5258 6.57874V6.58127Z",
    fill: "#C65327"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M96.5258 6.58517C97.4386 6.61039 98.2707 7.19541 98.2707 8.10823C98.2707 9.02106 97.4386 9.89102 96.5258 9.89102C95.6129 9.89102 94.8489 9.14966 94.8716 8.23684C94.8943 7.30636 95.6457 6.55743 96.5258 6.58265V6.58517Z",
    fill: "#C6542A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M96.5258 6.58644C97.4386 6.61166 98.2682 7.19668 98.2682 8.11203C98.2682 9.02738 97.4386 9.89481 96.5258 9.89481C95.6129 9.89481 94.8489 9.15346 94.8716 8.24063C94.8943 7.31015 95.6457 6.56375 96.5258 6.58644Z",
    fill: "#C7562C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M96.5316 6.58896C97.4445 6.61418 98.2741 7.20172 98.2741 8.11455C98.2741 9.02738 97.4445 9.89481 96.5316 9.89481C95.6188 9.89481 94.8548 9.15346 94.8774 8.24063C94.9001 7.31015 95.6516 6.56375 96.5316 6.58644V6.58896Z",
    fill: "#C7582E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M96.5316 6.59287C97.4445 6.61809 98.2741 7.20815 98.2741 8.12097C98.2741 9.0338 97.4445 9.89872 96.5316 9.89872C95.6188 9.89872 94.8548 9.15736 94.8774 8.24453C94.9001 7.31405 95.6516 6.56765 96.5316 6.59035V6.59287Z",
    fill: "#C85A31"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M96.5315 6.59287C97.4444 6.61809 98.2715 7.20815 98.2715 8.12097C98.2715 9.0338 97.4444 9.89872 96.5315 9.89872C95.6187 9.89872 94.8572 9.15736 94.8773 8.24453C94.9 7.31405 95.649 6.56765 96.5315 6.59035V6.59287Z",
    fill: "#C95C33"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M96.5384 6.59287C97.4512 6.61809 98.2783 7.21067 98.2783 8.1235C98.2783 9.03633 97.4512 9.89872 96.5384 9.89872C95.6255 9.89872 94.864 9.15736 94.8842 8.24453C94.9069 7.31405 95.6558 6.56765 96.5384 6.59035V6.59287Z",
    fill: "#C95E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M96.5384 6.59677C97.4512 6.62199 98.2758 7.21457 98.2758 8.1274C98.2758 9.04023 97.4512 9.90263 96.5384 9.90263C95.6255 9.90263 94.864 9.16127 94.8842 8.24844C94.9069 7.31796 95.6558 6.57156 96.5384 6.59425V6.59677Z",
    fill: "#CA6038"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M96.5384 6.60068C97.4512 6.6259 98.2758 7.221 98.2758 8.13383C98.2758 9.04666 97.4512 9.90653 96.5384 9.90653C95.6255 9.90653 94.864 9.16518 94.8842 8.25235C94.9069 7.32187 95.6558 6.57547 96.5384 6.59816V6.60068Z",
    fill: "#CA613A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M96.5384 6.60207C97.4512 6.62728 98.2758 7.22239 98.2758 8.13774C98.2758 9.05309 97.4512 9.91044 96.5384 9.91044C95.6255 9.91044 94.864 9.16908 94.8842 8.25625C94.9069 7.32577 95.6558 6.57937 96.5384 6.60207Z",
    fill: "#CB633C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M96.5442 6.60459C97.4571 6.62728 98.2791 7.22743 98.2791 8.14026C98.2791 9.05309 97.4571 9.91044 96.5442 9.91044C95.6314 9.91044 94.8699 9.16908 94.89 8.25625C94.9127 7.32829 95.6617 6.57937 96.5442 6.60207V6.60459Z",
    fill: "#CC653F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M96.5442 6.60402C97.4571 6.62671 98.2791 7.22938 98.2791 8.14221C98.2791 9.05504 97.4571 9.91239 96.5442 9.91239C95.6314 9.91239 94.8699 9.17103 94.89 8.25821C94.9102 7.33025 95.6617 6.58132 96.5442 6.60402Z",
    fill: "#CC6741"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M96.5442 6.60644C97.4571 6.62913 98.2791 7.2318 98.2791 8.14463C98.2791 9.05746 97.4596 9.91229 96.5442 9.91229C95.6289 9.91229 94.8699 9.17093 94.89 8.2581C94.9102 7.33014 95.6591 6.58374 96.5442 6.60392V6.60644Z",
    fill: "#CD6943"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M96.5442 6.61034C97.4571 6.63304 98.2766 7.23823 98.2766 8.15106C98.2766 9.06389 97.4571 9.91619 96.5442 9.91619C95.6314 9.91619 94.8699 9.17484 94.89 8.26201C94.9102 7.33405 95.6591 6.58765 96.5442 6.60782V6.61034Z",
    fill: "#CE6B46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M96.5442 6.6123C97.4571 6.63499 98.2766 7.24018 98.2766 8.15301C98.2766 9.06584 97.4571 9.91815 96.5442 9.91815C95.6314 9.91815 94.8699 9.17679 94.89 8.26396C94.9102 7.336 95.6591 6.5896 96.5442 6.60977V6.6123Z",
    fill: "#CE6C48"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M96.551 6.61425C97.4638 6.63694 98.2808 7.24465 98.2808 8.15748C98.2808 9.07031 97.4638 9.9201 96.551 9.9201C95.6381 9.9201 94.8791 9.17874 94.8968 8.26591C94.917 7.33796 95.6659 6.59155 96.551 6.61173V6.61425Z",
    fill: "#CF6E4A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M96.551 6.61816C97.4638 6.64085 98.2808 7.24856 98.2808 8.16139C98.2808 9.07422 97.4638 9.92401 96.551 9.92401C95.6381 9.92401 94.8791 9.18265 94.8968 8.26982C94.917 7.34186 95.6659 6.59546 96.551 6.61563V6.61816Z",
    fill: "#CF704C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M96.551 6.61816C97.4638 6.64085 98.2808 7.25108 98.2808 8.16391C98.2808 9.07674 97.4663 9.92401 96.551 9.92401C95.6356 9.92401 94.8791 9.18265 94.8968 8.26982C94.917 7.34186 95.6659 6.59546 96.551 6.61563V6.61816Z",
    fill: "#D0724F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M96.551 6.61954C97.4638 6.64223 98.2783 7.25247 98.2783 8.16782C98.2783 9.08317 97.4638 9.92791 96.551 9.92791C95.6381 9.92791 94.8791 9.18655 94.8968 8.27373C94.917 7.34577 95.6659 6.59937 96.551 6.61954Z",
    fill: "#D17451"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M96.5568 6.62206C97.4697 6.64223 98.2841 7.25751 98.2841 8.17034C98.2841 9.08317 97.4697 9.92791 96.5568 9.92791C95.644 9.92791 94.885 9.18655 94.9026 8.27373C94.9228 7.34577 95.6692 6.59937 96.5568 6.61954V6.62206Z",
    fill: "#D17653"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M96.5568 6.6254C97.4697 6.64557 98.2816 7.26337 98.2816 8.1762C98.2816 9.08903 97.4697 9.93377 96.5568 9.93377C95.644 9.93377 94.885 9.19241 94.9026 8.27959C94.9228 7.35163 95.6692 6.60523 96.5568 6.6254Z",
    fill: "#D27856"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M96.5568 6.62783C97.4697 6.648 98.2816 7.2658 98.2816 8.17863C98.2816 9.09146 97.4697 9.93368 96.5568 9.93368C95.644 9.93368 94.885 9.19232 94.9026 8.27949C94.9203 7.35154 95.6692 6.60766 96.5568 6.62531V6.62783Z",
    fill: "#D27958"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M96.5568 6.62978C97.4697 6.64996 98.2816 7.27028 98.2816 8.1831C98.2816 9.09593 97.4722 9.93563 96.5568 9.93563C95.6415 9.93563 94.885 9.19428 94.9026 8.28145C94.9203 7.35349 95.6692 6.60961 96.5568 6.62726V6.62978Z",
    fill: "#D37B5A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M96.5568 6.62978C97.4697 6.64996 98.2791 7.27027 98.2791 8.1831C98.2791 9.09593 97.4697 9.93563 96.5568 9.93563C95.644 9.93563 94.885 9.19427 94.9026 8.28145C94.9203 7.35601 95.6692 6.60961 96.5568 6.62726V6.62978Z",
    fill: "#D47D5D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M96.5568 6.63173C97.4697 6.65191 98.2791 7.27475 98.2791 8.18758C98.2791 9.10041 97.4697 9.93759 96.5568 9.93759C95.644 9.93759 94.885 9.19623 94.9026 8.2834C94.9203 7.35796 95.6692 6.61156 96.5568 6.62921V6.63173Z",
    fill: "#D47F5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M96.5568 6.63564C97.4696 6.65581 98.2765 7.27866 98.2765 8.19148C98.2765 9.10431 97.4696 9.94149 96.5568 9.94149C95.6439 9.94149 94.8874 9.20014 94.9026 8.28731C94.9202 7.36187 95.6666 6.61547 96.5568 6.63312V6.63564Z",
    fill: "#D58161"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M96.5568 6.63759C97.4696 6.65777 98.2765 7.28313 98.2765 8.19596C98.2765 9.10879 97.4696 9.94345 96.5568 9.94345C95.6439 9.94345 94.8874 9.20209 94.9026 8.28926C94.9202 7.36382 95.6666 6.61742 96.5568 6.63507V6.63759Z",
    fill: "#D68364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.5568 6.64093C97.4696 6.6611 98.2765 7.28899 98.2765 8.20182C98.2765 9.11465 97.4696 9.94931 96.5568 9.94931C95.6439 9.94931 94.8874 9.20795 94.9026 8.29512C94.9202 7.36968 95.6666 6.62328 96.5568 6.64093Z",
    fill: "#D68566"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M96.5626 6.64345C97.4754 6.66111 98.2798 7.29151 98.2798 8.20434C98.2798 9.11717 97.4754 9.94931 96.5626 9.94931C95.6498 9.94931 94.8933 9.20795 94.9084 8.29512C94.9261 7.36968 95.6725 6.62328 96.5626 6.64093V6.64345Z",
    fill: "#D78668"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M96.5626 6.64541C97.4754 6.66306 98.2798 7.29599 98.2798 8.20881C98.2798 9.12164 97.4754 9.95126 96.5626 9.95126C95.6498 9.95126 94.8933 9.2099 94.9084 8.29707C94.9261 7.37164 95.6725 6.62523 96.5626 6.64288V6.64541Z",
    fill: "#D7886B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M96.5626 6.64533C97.4754 6.66298 98.2773 7.29591 98.2773 8.20873C98.2773 9.12156 97.4754 9.95118 96.5626 9.95118C95.6498 9.95118 94.8933 9.20982 94.9084 8.29699C94.9236 7.37156 95.6725 6.62768 96.5626 6.6428V6.64533Z",
    fill: "#D88A6D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M96.5694 6.64728C97.4823 6.66493 98.2842 7.30038 98.2842 8.21321C98.2842 9.12604 97.4823 9.95313 96.5694 9.95313C95.6566 9.95313 94.9001 9.21177 94.9153 8.29894C94.9304 7.37351 95.6793 6.62963 96.5694 6.64476V6.64728Z",
    fill: "#D98C6F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M96.5694 6.64923C97.4823 6.66688 98.2842 7.30233 98.2842 8.21516C98.2842 9.12799 97.4823 9.95508 96.5694 9.95508C95.6566 9.95508 94.9001 9.21373 94.9153 8.3009C94.9304 7.37546 95.6768 6.63158 96.5694 6.64671V6.64923Z",
    fill: "#D98E72"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M96.5694 6.65314C97.4823 6.67079 98.2816 7.30876 98.2816 8.22159C98.2816 9.13442 97.4823 9.95899 96.5694 9.95899C95.6566 9.95899 94.9001 9.21763 94.9153 8.30481C94.9304 7.37937 95.6768 6.63549 96.5694 6.65062V6.65314Z",
    fill: "#DA9074"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M96.5694 6.65452C97.4823 6.67218 98.2816 7.31015 98.2816 8.2255C98.2816 9.14085 97.4823 9.9629 96.5694 9.9629C95.6566 9.9629 94.9001 9.22154 94.9153 8.30871C94.9304 7.38327 95.6768 6.63939 96.5694 6.65452Z",
    fill: "#DB9276"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M96.5752 6.65705C97.4881 6.6747 98.2849 7.31519 98.2849 8.22802C98.2849 9.14085 97.4881 9.9629 96.5752 9.9629C95.6624 9.9629 94.9084 9.22154 94.9211 8.30871C94.9362 7.38327 95.6826 6.63939 96.5752 6.65452V6.65705Z",
    fill: "#DB9379"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M96.5752 6.65843C97.4881 6.67356 98.2849 7.31909 98.2849 8.23192C98.2849 9.14475 97.4881 9.9668 96.5752 9.9668C95.6624 9.9668 94.9084 9.22544 94.9211 8.31262C94.9362 7.3897 95.6826 6.6433 96.5752 6.65843Z",
    fill: "#DC957B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M96.5752 6.66095C97.4881 6.67608 98.2849 7.32162 98.2849 8.23445C98.2849 9.14727 97.4881 9.9668 96.5752 9.9668C95.6624 9.9668 94.9084 9.22544 94.9211 8.31262C94.9362 7.3897 95.6826 6.6433 96.5752 6.65843V6.66095Z",
    fill: "#DC977D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.5752 6.6629C97.4881 6.67803 98.2824 7.32609 98.2824 8.23892C98.2824 9.15175 97.4881 9.96876 96.5752 9.96876C95.6624 9.96876 94.9084 9.2274 94.9211 8.31457C94.9362 7.39166 95.6826 6.64525 96.5752 6.66038V6.6629Z",
    fill: "#DD9980"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M96.5752 6.66479C97.4881 6.67992 98.2824 7.32798 98.2824 8.24081C98.2824 9.15363 97.4881 9.97064 96.5752 9.97064C95.6624 9.97064 94.9084 9.22928 94.9211 8.31645C94.9362 7.39354 95.6801 6.64966 96.5752 6.66227V6.66479Z",
    fill: "#DE9B82"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M96.5821 6.66674C97.4949 6.68187 98.2867 7.33245 98.2867 8.24528C98.2867 9.15811 97.4949 9.97259 96.5821 9.97259C95.6692 9.97259 94.9153 9.23123 94.9279 8.31841C94.9405 7.39549 95.6869 6.65161 96.5821 6.66422V6.66674Z",
    fill: "#DE9D84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M96.5821 6.67065C97.4949 6.68578 98.2867 7.33636 98.2867 8.24919C98.2867 9.16202 97.4949 9.9765 96.5821 9.9765C95.6692 9.9765 94.9153 9.23514 94.9279 8.32231C94.9405 7.3994 95.6869 6.65552 96.5821 6.66813V6.67065Z",
    fill: "#DF9F86"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M96.5821 6.67065C97.4949 6.68578 98.2867 7.33888 98.2867 8.25171C98.2867 9.16454 97.4949 9.9765 96.5821 9.9765C95.6692 9.9765 94.9153 9.23514 94.9279 8.32231C94.9405 7.3994 95.6869 6.65552 96.5821 6.66813V6.67065Z",
    fill: "#DFA089"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M96.5821 6.67203C97.4949 6.68716 98.2842 7.34026 98.2842 8.25561C98.2842 9.17096 97.4949 9.9804 96.5821 9.9804C95.6692 9.9804 94.9153 9.23905 94.9279 8.32622C94.9405 7.4033 95.6869 6.65942 96.5821 6.67203Z",
    fill: "#E0A28B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M96.5879 6.67456C97.5008 6.68968 98.29 7.34531 98.29 8.25814C98.29 9.17096 97.5008 9.9804 96.5879 9.9804C95.6751 9.9804 94.9211 9.23905 94.9337 8.32622C94.9464 7.4033 95.6928 6.65942 96.5879 6.67203V6.67456Z",
    fill: "#E1A48D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M96.5879 6.67594C97.5007 6.68855 98.29 7.34921 98.29 8.26204C98.29 9.17487 97.5032 9.98431 96.5879 9.98431C95.6725 9.98431 94.9236 9.24296 94.9337 8.33013C94.9463 7.40721 95.6927 6.66333 96.5879 6.67594Z",
    fill: "#E1A690"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M96.5879 6.67846C97.5007 6.69107 98.2875 7.35174 98.2875 8.26456C98.2875 9.17739 97.5007 9.98431 96.5879 9.98431C95.6751 9.98431 94.9236 9.24296 94.9337 8.33013C94.9463 7.40721 95.6902 6.66333 96.5879 6.67594V6.67846Z",
    fill: "#E2A892"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M96.5937 6.68237C97.5066 6.69498 98.2933 7.35816 98.2933 8.27099C98.2933 9.18382 97.5066 9.98822 96.5937 9.98822C95.6809 9.98822 94.9295 9.24686 94.9396 8.33403C94.9522 7.41112 95.696 6.66724 96.5937 6.67985V6.68237Z",
    fill: "#E3AA94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M96.5937 6.68231C97.5066 6.69492 98.2908 7.35811 98.2908 8.27093C98.2908 9.18376 97.5066 9.98816 96.5937 9.98816C95.6809 9.98816 94.9295 9.2468 94.9396 8.33398C94.9522 7.41106 95.696 6.6697 96.5937 6.67979V6.68231Z",
    fill: "#E3AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.5937 6.68622C97.5066 6.69882 98.2908 7.36453 98.2908 8.27736C98.2908 9.19019 97.5066 9.99207 96.5937 9.99207C95.6809 9.99207 94.9295 9.25071 94.9396 8.33788C94.9522 7.41749 95.696 6.67361 96.5937 6.6837V6.68622Z",
    fill: "#E4AD99"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M96.5937 6.68817C97.5066 6.70078 98.2908 7.36649 98.2908 8.27932C98.2908 9.19214 97.5091 9.99402 96.5937 9.99402C95.6784 9.99402 94.9295 9.25266 94.9396 8.33984C94.9496 7.41944 95.696 6.67556 96.5937 6.68565V6.68817Z",
    fill: "#E4AF9B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M96.5937 6.69012C97.5066 6.70273 98.2883 7.37096 98.2883 8.28379C98.2883 9.19662 97.5066 9.99598 96.5937 9.99598C95.6809 9.99598 94.9295 9.25462 94.9396 8.34179C94.9496 7.42139 95.696 6.67751 96.5937 6.6876V6.69012Z",
    fill: "#E5B19E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M96.5937 6.69346C97.5066 6.70607 98.2883 7.37682 98.2883 8.28965C98.2883 9.20248 97.5066 10.0018 96.5937 10.0018C95.6809 10.0018 94.9295 9.26048 94.9396 8.34765C94.9496 7.42725 95.696 6.68337 96.5937 6.69346Z",
    fill: "#E6B3A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M96.6006 6.69598C97.5134 6.70859 98.2926 7.37934 98.2926 8.29217C98.2926 9.205 97.5134 10.0018 96.6006 10.0018C95.6877 10.0018 94.9363 9.26048 94.9464 8.34765C94.9565 7.42725 95.7004 6.68337 96.6006 6.69346V6.69598Z",
    fill: "#E6B5A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M96.6006 6.69794C97.5134 6.70802 98.2926 7.38382 98.2926 8.29665C98.2926 9.20948 97.5134 10.0038 96.6006 10.0038C95.6877 10.0038 94.9363 9.26243 94.9464 8.3496C94.9565 7.42921 95.7004 6.68533 96.6006 6.69541V6.69794Z",
    fill: "#E7B7A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M96.6005 6.69794C97.5134 6.70802 98.2925 7.38382 98.2925 8.29665C98.2925 9.20948 97.5159 10.0038 96.6005 10.0038C95.6852 10.0038 94.9388 9.26243 94.9463 8.3496C94.9564 7.42921 95.7003 6.68533 96.6005 6.69541V6.69794Z",
    fill: "#E8B9A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M96.6064 6.69989C97.5192 6.70998 98.2959 7.38829 98.2959 8.30112C98.2959 9.21395 97.5192 10.0057 96.6064 10.0057C95.6936 10.0057 94.9446 9.26438 94.9522 8.35155C94.9623 7.43116 95.7062 6.68728 96.6064 6.69737V6.69989Z",
    fill: "#E8BAA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M96.6064 6.70379C97.5192 6.71388 98.2959 7.3922 98.2959 8.30503C98.2959 9.21786 97.5192 10.0096 96.6064 10.0096C95.6936 10.0096 94.9446 9.26829 94.9522 8.35546C94.9623 7.43507 95.7062 6.69119 96.6064 6.70127V6.70379Z",
    fill: "#E9BCAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M96.6064 6.7057C97.5192 6.71579 98.2934 7.39663 98.2934 8.30946C98.2934 9.22229 97.5192 10.0116 96.6064 10.0116C95.6936 10.0116 94.9446 9.2702 94.9522 8.35737C94.9623 7.43698 95.7062 6.69562 96.6064 6.70318V6.7057Z",
    fill: "#E9BEAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M96.6064 6.70709C97.5192 6.71718 98.2934 7.39801 98.2934 8.31336C98.2934 9.22872 97.5192 10.0155 96.6064 10.0155C95.6936 10.0155 94.9446 9.2741 94.9522 8.36127C94.9598 7.44088 95.7062 6.69952 96.6064 6.70709Z",
    fill: "#EAC0B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.6132 6.70961C97.5261 6.7197 98.3002 7.40306 98.3002 8.31589C98.3002 9.22871 97.5286 10.0155 96.6132 10.0155C95.6979 10.0155 94.9515 9.2741 94.959 8.36127C94.9666 7.44088 95.7105 6.69952 96.6132 6.70709V6.70961Z",
    fill: "#EBC2B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M96.6132 6.71099C97.5261 6.72108 98.2977 7.40696 98.2977 8.31979C98.2977 9.23262 97.5261 10.0194 96.6132 10.0194C95.7004 10.0194 94.9515 9.27801 94.959 8.36518C94.9666 7.44479 95.7105 6.70343 96.6132 6.71099Z",
    fill: "#EBC4B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M96.6132 6.71351C97.5261 6.7236 98.2977 7.40948 98.2977 8.32231C98.2977 9.23514 97.5261 10.0194 96.6132 10.0194C95.7004 10.0194 94.9515 9.27801 94.959 8.36518C94.9666 7.44731 95.7105 6.70343 96.6132 6.71099V6.71351Z",
    fill: "#ECC6B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M96.6132 6.71547C97.5261 6.72303 98.2952 7.41396 98.2952 8.32679C98.2952 9.23962 97.5261 10.0213 96.6132 10.0213C95.7004 10.0213 94.9515 9.27996 94.959 8.36714C94.9666 7.44926 95.7105 6.70538 96.6132 6.71295V6.71547Z",
    fill: "#ECC7B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M96.6132 6.71742C97.5261 6.72499 98.2952 7.41591 98.2952 8.32874C98.2952 9.24157 97.5261 10.0233 96.6132 10.0233C95.7004 10.0233 94.9515 9.28192 94.959 8.36909C94.9666 7.45122 95.7105 6.70734 96.6132 6.7149V6.71742Z",
    fill: "#EDC9BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M96.6191 6.72133C97.5319 6.72889 98.301 7.42234 98.301 8.33517C98.301 9.248 97.5319 10.0272 96.6191 10.0272C95.7062 10.0272 94.9598 9.28582 94.9649 8.37299C94.9724 7.45512 95.7163 6.71124 96.6191 6.71881V6.72133Z",
    fill: "#EECBBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M96.6191 6.72328C97.5319 6.73085 98.2985 7.42429 98.2985 8.33712C98.2985 9.24995 97.5319 10.0291 96.6191 10.0291C95.7062 10.0291 94.9598 9.28777 94.9649 8.37495C94.9724 7.45707 95.7138 6.7132 96.6191 6.72076V6.72328Z",
    fill: "#EECDC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M96.6191 6.72325C97.5319 6.73081 98.2985 7.42678 98.2985 8.33961C98.2985 9.25244 97.5319 10.0291 96.6191 10.0291C95.7062 10.0291 94.9598 9.28774 94.9649 8.37491C94.9724 7.45704 95.7138 6.71569 96.6191 6.72073V6.72325Z",
    fill: "#EFCFC3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M96.6191 6.72659C97.5319 6.73415 98.2959 7.43264 98.2959 8.34547C98.2959 9.2583 97.5319 10.035 96.6191 10.035C95.7062 10.035 94.9598 9.2936 94.9649 8.38077C94.9724 7.4629 95.7138 6.72154 96.6191 6.72659Z",
    fill: "#F0D1C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M96.6249 6.72911C97.5377 6.73668 98.3018 7.43517 98.3018 8.34799C98.3018 9.26082 97.5377 10.035 96.6249 10.035C95.7121 10.035 94.9657 9.2936 94.9707 8.38077C94.9758 7.4629 95.7197 6.72154 96.6249 6.72659V6.72911Z",
    fill: "#F0D2C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M96.6249 6.73049C97.5377 6.73806 98.3018 7.43907 98.3018 8.3519C98.3018 9.26473 97.5377 10.0389 96.6249 10.0389C95.7121 10.0389 94.9657 9.29751 94.9707 8.38468C94.9758 7.46681 95.7197 6.72545 96.6249 6.73049Z",
    fill: "#F1D4CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.6249 6.73302C97.5377 6.74058 98.2993 7.44159 98.2993 8.35442C98.2993 9.26725 97.5377 10.0389 96.6249 10.0389C95.7121 10.0389 94.9657 9.29751 94.9707 8.38468C94.9758 7.46681 95.7197 6.72545 96.6249 6.73049V6.73302Z",
    fill: "#F1D6CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M96.6318 6.73692C97.5446 6.74197 98.3061 7.44802 98.3061 8.36085C98.3061 9.27368 97.5446 10.0428 96.6318 10.0428C95.7189 10.0428 94.9725 9.30141 94.9776 8.38859C94.9826 7.47071 95.7265 6.72936 96.6318 6.7344V6.73692Z",
    fill: "#F2D8CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M96.6318 6.73692C97.5446 6.74197 98.3036 7.44802 98.3036 8.36085C98.3036 9.27368 97.5446 10.0428 96.6318 10.0428C95.7189 10.0428 94.9725 9.30141 94.9776 8.38859C94.9826 7.47071 95.724 6.72936 96.6318 6.7344V6.73692Z",
    fill: "#F3DAD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M96.6318 6.73888C97.5446 6.74392 98.3036 7.4525 98.3036 8.36532C98.3036 9.27815 97.5446 10.0447 96.6318 10.0447C95.7189 10.0447 94.9725 9.30337 94.9776 8.39054C94.9826 7.47267 95.724 6.73131 96.6318 6.73635V6.73888Z",
    fill: "#F3DCD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M96.6317 6.74026C97.5446 6.7453 98.3036 7.45388 98.3036 8.36923C98.3036 9.28458 97.5446 10.0486 96.6317 10.0486C95.7189 10.0486 94.975 9.30728 94.9775 8.39445C94.9826 7.4791 95.7239 6.73522 96.6317 6.74026Z",
    fill: "#F4DED5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.6317 6.74276C97.5446 6.74781 98.301 7.4589 98.301 8.37173C98.301 9.28456 97.5446 10.0486 96.6317 10.0486C95.7189 10.0486 94.975 9.30726 94.9775 8.39443C94.9826 7.47908 95.7239 6.73772 96.6317 6.74024V6.74276Z",
    fill: "#F4DFD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.6317 6.7461C97.5446 6.75114 98.301 7.46476 98.301 8.37759C98.301 9.29042 97.5446 10.0545 96.6317 10.0545C95.7189 10.0545 94.975 9.31311 94.9775 8.40029C94.9826 7.48494 95.7239 6.74358 96.6317 6.7461Z",
    fill: "#F5E1DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M96.6376 6.74862C97.5504 6.75366 98.3069 7.46728 98.3069 8.38011C98.3069 9.29294 97.5529 10.0545 96.6376 10.0545C95.7222 10.0545 94.9809 9.31311 94.9834 8.40029C94.9884 7.48494 95.7298 6.74358 96.6376 6.7461V6.74862Z",
    fill: "#F6E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M96.6376 6.74862C97.5504 6.75366 98.3044 7.46981 98.3044 8.38263C98.3044 9.29546 97.5504 10.0545 96.6376 10.0545C95.7248 10.0545 94.9809 9.31311 94.9834 8.40029C94.9859 7.48494 95.7298 6.74358 96.6376 6.7461V6.74862Z",
    fill: "#F6E5DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M96.6376 6.75058C97.5504 6.7531 98.3044 7.47176 98.3044 8.38459C98.3044 9.29742 97.5504 10.0564 96.6376 10.0564C95.7248 10.0564 94.9809 9.31507 94.9834 8.40224C94.9859 7.48689 95.7273 6.74553 96.6376 6.74805V6.75058Z",
    fill: "#F7E7E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M96.6444 6.75253C97.5573 6.75505 98.3087 7.47623 98.3087 8.38906C98.3087 9.30189 97.5573 10.0584 96.6444 10.0584C95.7316 10.0584 94.9877 9.31702 94.9902 8.40419C94.9928 7.48884 95.7341 6.74748 96.6444 6.75001V6.75253Z",
    fill: "#F8E9E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.6444 6.75643C97.5573 6.75896 98.3087 7.48014 98.3087 8.39297C98.3087 9.3058 97.5573 10.0623 96.6444 10.0623C95.7316 10.0623 94.9877 9.32093 94.9902 8.4081C94.9928 7.49275 95.7341 6.75139 96.6444 6.75391V6.75643Z",
    fill: "#F8EBE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M96.6444 6.75839C97.5573 6.76091 98.3087 7.48461 98.3087 8.39744C98.3087 9.31027 97.5598 10.0642 96.6444 10.0642C95.7291 10.0642 94.9877 9.32288 94.9902 8.41005C94.9928 7.4947 95.7341 6.75334 96.6444 6.75587V6.75839Z",
    fill: "#F9ECE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M96.6444 6.76173C97.5573 6.76425 98.3062 7.48795 98.3062 8.4033C98.3062 9.31865 97.5573 10.0701 96.6444 10.0701C95.7316 10.0701 94.9902 9.32874 94.9902 8.41591C94.9902 7.50056 95.7341 6.7592 96.6444 6.76173Z",
    fill: "#F9EEEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M96.6503 6.76424C97.5631 6.76424 98.312 7.49299 98.312 8.40582C98.312 9.31865 97.5631 10.0701 96.6503 10.0701C95.7375 10.0701 94.9961 9.32873 94.9961 8.4159C94.9961 7.50055 95.74 6.76172 96.6503 6.76172V6.76424Z",
    fill: "#FAF0EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M96.6503 6.76367C97.5631 6.76367 98.3095 7.49494 98.3095 8.40777C98.3095 9.3206 97.5631 10.072 96.6503 10.072C95.7375 10.072 94.9961 9.33069 94.9961 8.41786C94.9961 7.50251 95.74 6.76367 96.6503 6.76367Z",
    fill: "#FBF2EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.6503 6.76619C97.5631 6.76619 98.3095 7.49746 98.3095 8.41029C98.3095 9.32312 97.5631 10.072 96.6503 10.072C95.7375 10.072 94.9961 9.33069 94.9961 8.41786C94.9961 7.50251 95.7375 6.76367 96.6503 6.76367V6.76619Z",
    fill: "#FBF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.6503 6.76815C97.5631 6.76815 98.3095 7.50194 98.3095 8.41477C98.3095 9.3276 97.5656 10.074 96.6503 10.074C95.7349 10.074 94.9961 9.33264 94.9961 8.41981C94.9961 7.50698 95.7375 6.76562 96.6503 6.76562V6.76815Z",
    fill: "#FCF6F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M96.6503 6.77205C97.5631 6.77205 98.307 7.50585 98.307 8.41867C98.307 9.3315 97.5631 10.0779 96.6503 10.0779C95.7375 10.0779 94.9961 9.33655 94.9961 8.42372C94.9961 7.51089 95.7375 6.76953 96.6503 6.76953V6.77205Z",
    fill: "#FDF8F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M96.6561 6.77401C97.569 6.77401 98.3128 7.51032 98.3128 8.42315C98.3128 9.33598 97.569 10.0799 96.6561 10.0799C95.7433 10.0799 95.002 9.3385 95.002 8.42567C95.002 7.51284 95.7433 6.77148 96.6561 6.77148V6.77401Z",
    fill: "#FDF9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M96.6561 6.77596C97.569 6.77596 98.3103 7.51227 98.3103 8.4251C98.3103 9.33793 97.569 10.0818 96.6561 10.0818C95.7433 10.0818 95.002 9.34045 95.002 8.42762C95.002 7.51479 95.7433 6.77344 96.6561 6.77344V6.77596Z",
    fill: "#FEFBFA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1480_9219",
    x1: 97.146,
    y1: 9.24562,
    x2: 96.0012,
    y2: 7.45526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1480_9219",
    x1: 96.9644,
    y1: 9.22292,
    x2: 95.2926,
    y2: 5.95238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF6D00",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5900",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF4800",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF3B00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3200",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF2C00",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF2B00",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1480_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 3.2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1480_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5081,
    height: 13.824,
    fill: "white",
    transform: "translate(30.2471 1.08789)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1480_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(63.9971)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1480_9219"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 24,
    height: 16,
    rx: 3.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.011bedfd9f355fd1d47a68a2f1aebdb3.svg";
export { ForwardRef as ReactComponent };